export default __webpack_public_path__ + "static/logo-b5c9b71d32730bc06fb48ead127514f4.png";